module.exports = __webpack_public_path__ + "img/Mastercard.f6b959ae.svg";